"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sectionBase = exports.flags = exports.entryBase = exports.sectionQualificationMinSchemaDef = exports.entryCentreSchemaDef = void 0;
const joi_1 = __importDefault(require("joi"));
const general_1 = require("../general");
const schemaValidator_1 = require("../../util/schemaValidator");
const Component_1 = require("../internal/Component");
const ComponentSeries_1 = require("../internal/ComponentSeries");
const BusinessUnit_1 = require("../internal/BusinessUnit");
const Centre_1 = require("../internal/Centre");
const Qualification_1 = require("../internal/Qualification");
const fileFormats_1 = require("../fileFormats");
const ComponentSeries_2 = require("../internal/ComponentSeries");
exports.entryCentreSchemaDef = {
    id: Centre_1.centreSchemaDef.id,
    name: Centre_1.centreSchemaDef.name,
    zone: Centre_1.centreSchemaDef.zone,
    zoneId: Centre_1.centreSchemaDef.zoneId,
};
exports.sectionQualificationMinSchemaDef = {
    id: Qualification_1.qualificationMinSchemaDef.id,
    name: Qualification_1.qualificationMinSchemaDef.name,
};
exports.entryBase = Object.assign(Object.assign({}, general_1.daoObjSchemaDef), { businessUnit: (0, schemaValidator_1.objectSchema)(BusinessUnit_1.businessUnitSchemaDef).required(), centre: (0, schemaValidator_1.objectSchema)(exports.entryCentreSchemaDef).required(), series: (0, schemaValidator_1.objectSchema)(ComponentSeries_2.componentSeriesSchemaDef).required(), assessment: (0, schemaValidator_1.objectSchema)(Qualification_1.assessmentSchemaDef).required(), component: (0, schemaValidator_1.objectSchema)(Component_1.entryComponent).required(), learner: joi_1.default.string().required(), learnerNumber: joi_1.default.number().required(), learnerUniqueId: joi_1.default.string(), qualification: (0, schemaValidator_1.objectSchema)(exports.sectionQualificationMinSchemaDef).required(), submissionOffset: (0, schemaValidator_1.objectSchema)(ComponentSeries_1.submissionOffsetSchemaDef), mark: joi_1.default.number() });
exports.flags = {
    plagiarismAndCollusion: joi_1.default.boolean().required(),
    declarationOfAuthenticity: joi_1.default.boolean().required(),
};
exports.sectionBase = {
    id: Component_1.componentSectionSchemaDef.id,
    name: Component_1.componentSectionSchemaDef.name,
    flags: (0, schemaValidator_1.objectSchema)(exports.flags).required(),
    fileTypes: (0, schemaValidator_1.arraySchema)(fileFormats_1.fileTypeSchemaDef).default([]),
    isMandatory: joi_1.default.boolean().optional(),
    allowMultipleFiles: joi_1.default.boolean().optional(),
};
